<template>
  <div class="flex-1 max-w-[552px] min-h-[calc(var(--app-height))] mx-auto">
    <div class="py-0 flex flex-col justify-center items-start w-full">
      <h1 class="text-[2rem] leading-[2.5rem] font-black text-[#433D31] tracking-[-0.03em]">
        Reset Email
      </h1>
      <p class="text-[1rem] leading-[1.5rem] font-semibold text-[#433D31] pt-[8px]">
        OK, no worries - share your contact with us and we will be in touch with you soon!
      </p>

      <div class="w-full">
        <div class="mt-[24px]">
          <TextInput
            v-model="name"
            class="w-full"
            label="Full name"
            type="text"
            labelClasses="text-[#191817] text-[0.875rem] leading-[1.25rem] font-semibold pb-[4px]"
            placeholder="Alicia Tan"
          />
        </div>

        <div class="mt-[24px]">
          <TextInput
            v-model="cg"
            class="w-full"
            label="Connect Group"
            type="text"
            labelClasses="text-[#191817] text-[0.875rem] leading-[1.25rem] font-semibold pb-[4px]"
            placeholder="Enter Connect Group"
          />
        </div>

        <div class="mt-[24px]">
          <label
            class="block text-[0.875rem] leading-[1.25rem] text-[#191817] font-semibold mb-[8px]"
          >
            Mobile number
          </label>
          <div class="flex w-full">
            <select
              v-model="countryCode"
              :class="[
                'h-[56px] border  bg-[#F8F9F9] rounded-l-[8px] px-[12px] text-[1rem] text-[#373E49]  focus:bg-white focus:ring-0 focus:outline-none ',
                hasMobileError
                  ? 'border-[#B80A0A] focus:border-[#B80A0A]'
                  : 'border-[#637083] focus:border-[#056DFF]',
              ]"
            >
              <option value="+65">+65</option>
              <option value="+1">+1</option>
              <option value="+44">+44</option>
              <option value="+86">+86</option>
            </select>
            <input
              v-model="mobileNumber"
              type="tel"
              placeholder="9123 4567"
              :class="[
                'h-[56px] border-t border-r border-b  bg-[#F8F9F9] rounded-r-[8px] px-[12px] text-[1rem] leading-[1.5rem] flex-1 text-[#373E49] placeholder-[#637083] focus:bg-white focus:ring-0 focus:outline-none',
                hasMobileError
                  ? 'border-[#B80A0A] focus:border-[#B80A0A]'
                  : 'border-[#637083] focus:border-[#056DFF]',
              ]"
            />
          </div>
          <p
            v-if="hasMobileError"
            class="text-[1rem] text-[#B80A0A] leading-[1.5rem] mt-[4px] block"
          >
            {{ mobileNumberError }}
          </p>
        </div>

        <div class="mt-[24px]">
          <TextInput
            v-model="email"
            class="w-full"
            label="Email"
            type="email"
            labelClasses="text-[#191817] text-[0.875rem] leading-[1.25rem] font-semibold pb-[4px]"
            placeholder="example@email.com"
            :error="emailError"
          />
        </div>

        <p class="text-[1rem] leading-[1.5rem] font-semibold text-[#433D31] pt-[40px]">
          Share the login issue(s) you faced:
        </p>
        <!-- Button options -->
        <div class="flex flex-col gap-4 w-full mt-[16px]">
          <OptionButton
            text="I forgot my email"
            :is-selected="selectedOption === 'email'"
            @click="selectOption('email')"
          />
          <OptionButton
            text="I forgot both my email & password"
            :is-selected="selectedOption === 'email & password'"
            @click="selectOption('email & password')"
          />
        </div>

        <div class="mt-[48px] right-0 px-[24px] pb-[32px] w-full">
          <BaseButton
            solid-classes="block h-[56px] bg-[#42362B] border-0 !rounded-[100px] text-white text-[1rem] leading-[1.5rem] font-bold items-center"
            full-width
            disabled-classes="disabled:text-[#99A4B2] disabled:border-[#D3D8DE] disabled:bg-[#F0F2F4]"
            :disabled="loading || !canSave"
            @click="submit(email)"
          >
            {{ loading ? 'Loading...' : 'Submit' }}
          </BaseButton>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TextInput from '@/components/design/TextInput.vue';
import OptionButton from '@/components/common/OptionButton.vue';
import BaseButton from '@/components/design/BaseButton.vue';

export default {
  components: {
    TextInput,
    OptionButton,
    BaseButton,
  },

  data() {
    return {
      countryCode: '+65',
      name: '',
      cg: '',
      mobileNumber: '',
      email: '',
      selectedOption: null,
      loading: false,
      emailError: '',
      mobileNumberError: '',
      hasMobileError: false,
    };
  },
  computed: {
    canSave() {
      return (
        this.name.length > 0 &&
        this.cg.length > 0 &&
        this.mobileNumber.length > 0 &&
        this.email.length > 0 &&
        this.selectedOption != null
      );
    },
  },
  methods: {
    selectOption(option) {
      this.selectedOption = option;
    },
    async submit() {
      //reset previous errors
      this.emailError = '';
      this.mobileNumberError = '';
      if (!this.validateEmail(this.email) || !this.validateMobileNumber(this.mobileNumber)) {
        if (!this.validateEmail(this.email)) {
          this.emailError = 'Email is invalid.';
        }

        if (!this.validateMobileNumber(this.mobileNumber)) {
          this.hasMobileError = true;
          this.mobileNumberError = 'Phone number is invalid.';
        }
        return;
      }
      this.loading = true;

      const formData = {
        countryCode: this.countryCode,
        contactNumber: this.mobileNumber,
        email: this.email,
        fullName: this.name,
        cg: this.cg,
      };

      try {
        //To-do: selectedOption should be submitted
        await this.$store.dispatch('forgotCredentials/submitEmailForm', formData);
        this.$emit('next');
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    validateEmail(email) {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
    },
    validateMobileNumber(number) {
      const regex = /^[0-9]{8,15}$/;
      return regex.test(number.replace(/\s/g, ''));
    },
  },
};
</script>
